/**
 * The languages somebody can answer in. One list, shared: the take pages offer it, the settings
 * page ticks it, and the reports read a label out of it. A code that is not here cannot be chosen.
 */
export const CANDIDATE_LANGUAGES: readonly { code: string; label: string }[] = [
    { code: 'en-IN', label: 'English' },
    { code: 'hi-IN', label: 'Hindi' },
    { code: 'ta-IN', label: 'Tamil' },
    { code: 'te-IN', label: 'Telugu' },
    { code: 'bn-IN', label: 'Bengali' },
    { code: 'mr-IN', label: 'Marathi' },
    { code: 'gu-IN', label: 'Gujarati' },
    { code: 'kn-IN', label: 'Kannada' },
    { code: 'ml-IN', label: 'Malayalam' },
    { code: 'pa-IN', label: 'Punjabi' }
];

/**
 * The readable name for a code. Falls back to the code itself, so an older response saved against
 * a language since removed from the list still says something rather than nothing.
 */
export function languageLabel(code: string | null | undefined): string {
    if (!code) {
        return '';
    }

    return CANDIDATE_LANGUAGES.find((l) => l.code === code)?.label ?? code;
}
